import { render, staticRenderFns } from "./HotelOwnerActionsLayout.vue?vue&type=template&id=b6cbfa82&scoped=true&"
import script from "./HotelOwnerActionsLayout.vue?vue&type=script&lang=js&"
export * from "./HotelOwnerActionsLayout.vue?vue&type=script&lang=js&"
import style0 from "./HotelOwnerActionsLayout.vue?vue&type=style&index=0&id=b6cbfa82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cbfa82",
  null
  
)

export default component.exports